import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UnauthorizedPage.css';

const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="unauthorized-wrapper">
      <div className="unauthorized-left">
        <div className="unauthorized-container">
          <div className="unauthorized-logo-section">
            <img src="/images/Logo.png" alt="Cnerzy Logo" className="unauthorized-logo" />
          </div>
          
          <div className="unauthorized-content">
            <div className="unauthorized-icon">
              <i className="fas fa-lock"></i>
            </div>
            
            <h1 className="unauthorized-title">Access Denied</h1>
            
            <p className="unauthorized-message">
              You don't have permission to access this page.
            </p>
            
            <p className="unauthorized-details">
              If you believe this is a mistake, please contact your administrator.
            </p>

            <div className="unauthorized-actions">
              <button 
                className="btn btn-primary w-100"
                onClick={() => navigate(-1)}
                style={{ backgroundColor: "#181D4C", height: "40px" }}
              >
                <i className="fas fa-arrow-left"></i> Go Back
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <div className="unauthorized-right d-none d-md-flex align-items-center justify-content-center">
        <img
          src="/images/BG.png"
          alt="Background"
          className="img-fluid"
          style={{ maxHeight: "90%", maxWidth: "90%", objectFit: "contain" }}
        />
      </div>
    </div>
  );
};

export default UnauthorizedPage;
